import {
    Circle,
    Delete,
    InsertDriveFile as InsertDriveFileIcon,
} from '@mui/icons-material';
import {
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControlLabel,
    Grid,
    IconButton,
    LinearProgress,
    Switch,
    Tooltip,
    Zoom,
} from '@mui/material';
import {
    DataGridPro,
    GridToolbarContainer,
    GridToolbarQuickFilter,
    itIT,
} from '@mui/x-data-grid-pro';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import unsplash from '../api/unsplash';
import { CustomFooterPersonalized } from '../utils/CustomFooterPersonalized';
import DettaglioCorsi from './DettaglioCorsi';
import GlobalSnackbar from './Snackbar';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

const Corsi = () => {
    const [filtro, setFiltro] = useState({
        verde: true,
        arancione: true,
        rosso: true,
        viola: true,
        nonAttivi: false,
        attivi: true,
        online: true,
        videoconferenza: true,
        aula: true,
    });
    const [corsi, setCorsi] = useState([]);
    const [corsiVisibili, setCorsiVisibili] = useState([]);
    const [loading, setLoading] = useState(true);
    const [anagraficaCorsi, setAnagraficaCorsi] = useState([]);
    const [modalita, setModalita] = useState([]);
    const [formatori, setFormatori] = useState([]);
    const [modalitaFatturazioneCorsi, setModalitaFatturazioneCorsi] = useState(
        []
    );
    const [openSnack, setOpenSnack] = useState(false);
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    });

    const columns = [
        {
            field: 'Actions',
            filterable: false,
            headerName: 'Azioni',
            width: 120,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (
                params //mi aiuta a mettere il valore
            ) => (
                <>
                    <DettaglioCorsi
                        Title="Modifica edizione"
                        Corsi={anagraficaCorsi}
                        Modalita={modalita}
                        Formatori={formatori}
                        Operation="Edit"
                        id="edit"
                        corsoH={params.row}
                        /* CorsiAttestati={corsiAttestati}
            Stampa={stampa} */
                        ModalitaFatturazioneCorsi={modalitaFatturazioneCorsi}
                        reloadCorsi={loadCorsi}
                        reloadFormatori={loadFormatori}
                        Tipo={params.row.Tipo}
                        Aggiornamento={params.row.Aggiornamento}
                        snack={snack}
                        openSnack={openSnack}
                        handleCloseSnack={handleCloseSnack}
                        setSnack={setSnack}
                        setOpenSnack={setOpenSnack}
                        isEdizioneModal
                    />
                    {params.row.Attivo === 1 && (
                        <DeleteDialog
                            corso={params.row}
                            myFunction={handleDelete}
                        />
                    )}
                </>
            ),
        },
        {
            field: 'AttestatoCustom',
            filterable: false,
            headerName: 'Attestato custom',
            width: 130,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <AttestatoCustomAula
                    corso={params.row}
                    setSnack={setSnack}
                    setOpenSnack={setOpenSnack}
                />
            ),
        },
        {
            field: 'Attivo',
            headerName: 'Attivo',
            width: 70,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => (
                <Circle
                    sx={{
                        color: params.row.Attivo === 1 ? '#40C18F' : '#FF2768',
                    }}
                >
                    {' '}
                </Circle>
            ),
        },
        {
            field: 'Tipo',
            headerName: 'Codice',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'NomeEdizione',
            headerName: 'Nome edizione',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Descrizione',
            headerName: 'Descrizione',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Aggiornamento',
            headerName: 'Agg.',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },

        {
            field: 'ModalitaDescrizione',
            headerName: 'Modalità',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Luogo',
            headerName: 'Luogo',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'DataInizio',
            headerName: 'Data Inizio',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.DataInizio
                            ? moment(params.row.DataInizio).format('DD/MM/YYYY')
                            : ''}
                    </div>
                );
            },
        },
        {
            field: 'DataFine',
            headerName: 'Data Fine',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.DataFine && params.row.Modalita !== 2
                            ? moment(params.row.DataFine).format('DD/MM/YYYY')
                            : ''}
                    </div>
                );
            },
        },
        {
            field: 'Note',
            headerName: 'Note',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'Durata',
            headerName: 'Durata',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'nGiorni',
            headerName: 'N° Giorni',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
    ];

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <GridToolbarQuickFilter placeholder="Cerca..." />
                    <FormControlLabel
                        sx={{
                            marginBottom: '0px!important',
                            fontSize: '13px',
                            color: '#11526F',
                        }}
                        control={
                            <Switch
                                size="small"
                                checked={filtro.attivi}
                                onChange={(e) => filter(e, 'attivi')}
                            />
                        }
                        label="Attivi"
                    />
                    <FormControlLabel
                        sx={{
                            marginBottom: '0px!important',
                            fontSize: '13px',
                            color: '#11526F',
                        }}
                        control={
                            <Switch
                                size="small"
                                checked={filtro.nonAttivi}
                                onChange={(e) => filter(e, 'nonAttivi')}
                            />
                        }
                        label="Non attivi"
                    />
                    <FormControlLabel
                        sx={{
                            marginBottom: '0px!important',
                            fontSize: '13px',
                            color: '#11526F',
                        }}
                        control={
                            <Switch
                                size="small"
                                checked={filtro.online}
                                onChange={(e) => filter(e, 'online')}
                            />
                        }
                        label="Online"
                    />
                    <FormControlLabel
                        sx={{
                            marginBottom: '0px!important',
                            fontSize: '13px',
                            color: '#11526F',
                        }}
                        control={
                            <Switch
                                size="small"
                                checked={filtro.videoconferenza}
                                onChange={(e) =>
                                    filter(e, 'videoconferenza')
                                }
                            />
                        }
                        label="Videoconferenza"
                    />
                    <FormControlLabel
                        sx={{
                            marginBottom: '0px!important',
                            fontSize: '13px',
                            color: '#11526F',
                        }}
                        control={
                            <Switch
                                size="small"
                                checked={filtro.aula}
                                onChange={(e) => filter(e, 'aula')}
                            />
                        }
                        label="Aula"
                    />
                </Grid>
            </GridToolbarContainer>
        );
    }

    const handleDelete = async (corso) => {
        try {
            if (corso.ID) {
                try {
                    const materialiResponse = await unsplash.get(
                        `getMaterialeEdizione/${corso.ID}`,
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                            },
                        }
                    );

                    if (
                        materialiResponse.data.files &&
                        materialiResponse.data.files.length > 0
                    ) {
                        await unsplash.delete(
                            `eliminaMaterialeEdizione/${corso.ID}`,
                            {
                                headers: {
                                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                                },
                            }
                        );
                        console.log(
                            `Eliminati ${materialiResponse.data.files.length} file associati al corso ${corso.ID}`
                        );
                    } else {
                        console.log(
                            `Nessun file da eliminare per il corso ${corso.ID}`
                        );
                    }
                } catch (fileErr) {
                    if (fileErr.response && fileErr.response.status === 404) {
                        console.log(
                            `Nessun materiale trovato per il corso ${corso.ID}`
                        );
                    } else {
                        console.error(
                            'Errore durante la cancellazione dei file associati:',
                            fileErr
                        );
                        setSnack({
                            severity: 'warning',
                            messaggio:
                                'Errore nella rimozione dei materiali associati',
                        });
                        setOpenSnack(true);
                        return;
                    }
                }
            }

            const response = await unsplash.delete('corsi', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                data: {
                    disattivaID: corso.ID,
                },
            });

            if (response?.data?.blocked) {
                setSnack({
                    severity: 'warning',
                    messaggio:
                        response.data.message || "Impossibile eliminare l'aula",
                });
                setOpenSnack(true);
                return;
            }

            await loadCorsi();

            setSnack({
                severity: 'success',
                messaggio: 'Corso eliminato con successo',
            });
            setOpenSnack(true);
        } catch (error) {
            setSnack({
                severity: 'error',
                messaggio: "Errore durante l'eliminazione",
            });
            setOpenSnack(true);
        }
    };

    const loadCorsi = async () => {
        let response = await unsplash.get('corsi', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
        });
        setCorsi(response.data.data);
        setCorsiVisibili(response.data.data.filter((el) => el.Attivo === 1));
        setLoading(false);
    };

    const loadFormatori = async () => {
        let responseFormatori = await unsplash.get('formatori', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
        });
        const formatoriAttvi = responseFormatori.data.data.filter(
            (a) => a.Attivo === 1
        );
        setFormatori(formatoriAttvi);
    };

    const filter = (e, tipologia) => {
        let f = { ...filtro };
        f[tipologia] = e.target.checked;
        setFiltro(f);

        let corsiTemp = corsi;

        if (!f.nonAttivi) {
            corsiTemp = corsiTemp.filter((c) => c.Attivo !== 0);
        }

        if (!f.attivi) {
            corsiTemp = corsiTemp.filter((c) => c.Attivo !== 1);
        }

        corsiTemp = corsiTemp.filter((corso) => {
            const modalita = Number(corso.Modalita);
            if (modalita === 2) {
                return f.online;
            }
            if (modalita === 3) {
                return f.videoconferenza;
            }
            if (modalita === 1) {
                return f.aula;
            }
            return true;
        });
        setCorsiVisibili(corsiTemp);
    };

    useEffect(() => {
        // è un loop qui carico i dati
        const fetchData = async () => {
            try {
                loadCorsi();

                let responsecorsi = await unsplash.get(
                    'anagraficaCorsi',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    } //props.idAzienda}}
                );

                setAnagraficaCorsi(responsecorsi.data.data);

                let responseFormatori = await unsplash.get(
                    'formatori',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    } //props.idAzienda}}
                );
                const formatoriAttvi = responseFormatori.data.data.filter(
                    (a) => a.Attivo === 1
                );
                setFormatori(formatoriAttvi);
                let responseModalitaCorsi = await unsplash.get(
                    'modalitaCorsi',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    } //props.idAzienda}}
                );
                setModalita(responseModalitaCorsi.data.data);

                let responseModalitaFatturazioneCorsi = await unsplash.get(
                    'modalitaFatturazioneCorsi',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    } //props.idAzienda}}
                );
                setModalitaFatturazioneCorsi(
                    responseModalitaFatturazioneCorsi.data.data
                );
            } catch (error) {
                console.error(error.message);
            }
        };

        fetchData();
    }, []);

    return (
        <>
            <GlobalSnackbar
                severity={snack.severity}
                messaggio={snack.messaggio}
                autoHideDuration={snack.autoHideDuration}
                openSnack={openSnack}
                handleCloseSnack={handleCloseSnack}
            />
            <Grid item xs={12}>
                <Card>
                    <CardContent>
                        <DettaglioCorsi
                            Title="Crea edizione"
                            Corsi={anagraficaCorsi}
                            Modalita={modalita}
                            Formatori={formatori}
                            Operation="Nuovo"
                            ModalitaFatturazioneCorsi={
                                modalitaFatturazioneCorsi
                            }
                            reloadCorsi={loadCorsi}
                            reloadFormatori={loadFormatori}
                            snack={snack}
                            openSnack={openSnack}
                            handleCloseSnack={handleCloseSnack}
                            setSnack={setSnack}
                            setOpenSnack={setOpenSnack}
                            isEdizioneModal
                        />
                        <Box
                            sx={{
                                height: { xs: '75vh', md: '60vh', xl: '75vh' },
                                width: 1,
                            }}
                        >
                            <DataGridPro
                                initialState={{
                                    pinnedColumns: { left: ['Actions'] },
                                }}
                                sx={{ fontSize: 12 }}
                                components={{
                                    Toolbar: CustomToolbar,
                                    Footer: CustomFooterPersonalized,
                                }}
                                slots={{
                                    loadingOverlay: LinearProgress,
                                }}
                                loading={loading}
                                localeText={
                                    itIT.components.MuiDataGrid.defaultProps
                                        .localeText
                                }
                                rows={corsiVisibili}
                                columns={columns}
                                getRowId={(row) => row.ID}
                                pageSize={100}
                                /* onRowDoubleClick={async (params, event) => {
                        await setCorsoHSel(params.row);

                        handleCorsiAttestati(
                          params.row.Tipo,
                          params.row.Aggiornamento
                        );
                        document.getElementById("edit").click();
                      }} */
                            />
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        </>
    );
};

export default Corsi;

const AttestatoCustomAula = ({ corso, setSnack, setOpenSnack }) => {
    const [loading, setLoading] = useState(false);

    const notify = (severity, messaggio) => {
        setSnack({ severity, messaggio });
        setOpenSnack(true);
    };

    const getErrorMessage = async (error, fallback) => {
        const data = error?.response?.data;
        if (data instanceof Blob) {
            try {
                const text = await data.text();
                const payload = JSON.parse(text);
                return payload?.message || fallback;
            } catch {
                return fallback;
            }
        }
        return data?.message || fallback;
    };

    const handleView = async () => {
        if (!corso?.AttestatoCustomID || loading) {
            return;
        }

        setLoading(true);
        try {
            const response = await unsplash.get(
                `anagraficaCorsi/${encodeURIComponent(
                    corso.Tipo || ''
                )}/attestato-custom/download`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                    responseType: 'blob',
                }
            );
            const blob = new Blob([response.data], {
                type:
                    response.headers?.['content-type'] ||
                    corso.AttestatoCustomMimeType ||
                    'application/pdf',
            });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
            setTimeout(() => window.URL.revokeObjectURL(url), 60000);
        } catch (error) {
            notify(
                'error',
                await getErrorMessage(
                    error,
                    "Errore durante l'apertura dell'attestato custom"
                )
            );
        } finally {
            setLoading(false);
        }
    };

    if (!corso?.AttestatoCustomID) {
        return null;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
            }}
        >
            {loading ? (
                <CircularProgress size={22} />
            ) : (
                <Tooltip
                    title={
                        corso.AttestatoCustomFilename ||
                        'Visualizza attestato custom'
                    }
                >
                    <IconButton size="small" onClick={handleView}>
                        <InsertDriveFileIcon
                            sx={{ color: '#11526F' }}
                            fontSize="small"
                        />
                    </IconButton>
                </Tooltip>
            )}
        </Box>
    );
};

const DeleteDialog = (props) => {
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <IconButton
                disabled={props.disabled}
                aria-label="edit"
                onClick={handleClickOpen}
            >
                <Delete
                    style={{ height: '2rem', width: '2rem', color: '#FF2768' }}
                />
            </IconButton>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                TransitionComponent={Transition}
            >
                <DialogTitle id="alert-dialog-title">
                    Eliminare Corso
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Attenzione, sei sicuro di voler eliminare il corso:{' '}
                        <br />
                        <b>{props.corso?.Descrizione}</b>?
                    </DialogContentText>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        px: 2,
                    }}
                >
                    <Button onClick={handleClose}>annulla</Button>
                    <Button
                        disabled={loading}
                        onClick={async () => {
                            setLoading(true);
                            await props.myFunction(props.corso);
                            setOpen(false);
                            setLoading(false);
                        }}
                    >
                        Conferma
                        {loading && (
                            <CircularProgress
                                sx={{
                                    marginLeft: 1,
                                }}
                                size={20}
                            />
                        )}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
